import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso ?? "—";
  }
}

export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return iso ?? "—";
  }
}

export function formatCurrency(value: number | string | null | undefined): string {
  const n = toNumberOrNull(value);
  if (n == null) return "—";
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n);
}

/**
 * Coage numeric que a API manda como string (numeric do pg vira string no
 * adapter) para number, sem quebrar em valor vazio/nulo/nao-numerico.
 * Usar em TODO campo que a API tipa como `number | string | null`
 * (ex.: sisplan.price) antes de aritmetica ou .toFixed.
 */
export function toNumberOrNull(value: number | string | null | undefined): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

const ROLE_LABEL: Record<string, string> = {
  super_admin: "Super admin",
  admin: "Admin",
  usuario: "Usuário",
};

/**
 * Rotulo legivel de papel pro rodape do menu e header (nunca o enum cru
 * "super_admin" — achado do smoke comparativo 2026-09-22: prototipo mede
 * "Super admin", producao mostrava o valor de banco). Sem entrada mapeada,
 * capitaliza a primeira letra em vez de vazar o snake_case.
 */
export function roleLabel(role: string | null | undefined): string {
  if (!role) return "—";
  return ROLE_LABEL[role] ?? role.charAt(0).toUpperCase() + role.slice(1).replace(/_/g, " ");
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso).getTime();
  const diff = Date.now() - d;
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return "agora";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}min atrás`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h atrás`;
  const days = Math.floor(h / 24);
  if (days < 30) return `${days}d atrás`;
  return formatDateShort(iso);
}
